var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('PageSpinner'):_vm._e(),(_vm.email)?[_c('div',{staticClass:"btn-add-staff"},[_c('router-link',{attrs:{"to":{ name: 'add-staff' }}},[_vm._v("ДОБАВИ СЛУЖИТЕЛ")])],1)]:_vm._e(),_c('Card',{attrs:{"data":_vm.staff_members}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }